import { MyrAPIService } from '../../../../api/myr/myrAPI';
import { deleteAccountSvc } from '../../sharedAPI.services';
import { MyrAPIEndpoints } from '../../../../api/myr/myrAPIEndpoints.constant';

export function getALinksAndNLStatus() {
    return MyrAPIService.sendRequest(`${MyrAPIEndpoints.SERVICE}/agreement`, 'GET');
}

export function deleteAccount(data, credentials) {
    return deleteAccountSvc(data, credentials);
}

export function updateNletterStatus(updatedData) {
    const { serviceUuid, nlSubscription } = updatedData;
    return MyrAPIService.sendRequest(
        `${MyrAPIEndpoints.SERVICE}/${serviceUuid}/newsletter`,
        'PUT',
        {
            nlSubscription,
        },
    );
}
